import React from 'react';
import { CloudSunIcon, CoffeeIcon, SunMediumIcon, BoxIcon } from 'lucide-react';
const essentials = [{
  title: 'Best time to trek',
  detail: 'March to May and late September to November',
  icon: SunMediumIcon,
  text: 'Autumn brings the clearest mountain views and settled skies after the monsoon. Spring offers warmer days, rhododendron colour in the lower valleys, and a quieter feeling on the trail. Both seasons reward early planning for permits and preferred lodges.'
}, {
  title: 'Weather & temperature',
  detail: 'Layering is essential above 3,000 metres',
  icon: CloudSunIcon,
  text: 'Conditions shift quickly with altitude. Lower valleys can feel mild during the day, while mornings around Samagaun and Larkya La are often below freezing. A warm insulating layer, waterproof shell, gloves, and sun protection are essential in every season.'
}, {
  title: 'Food & drinks',
  detail: 'Simple, nourishing meals in family-run lodges',
  icon: CoffeeIcon,
  text: 'Tea houses serve dal bhat, noodle soups, potatoes, rice dishes, eggs, and seasonal vegetables. Menus become simpler at higher altitude, but hot meals remain a welcome part of the rhythm. Bring a reusable bottle and use treated or boiled water throughout.'
}, {
  title: 'Wi-Fi & internet',
  detail: 'Available in places, never guaranteed',
  icon: BoxIcon,
  text: 'Many lower-elevation lodges offer Wi-Fi for a small local charge. As the route climbs, connection becomes slower and less dependable, often relying on solar power. Download maps and important documents before leaving Kathmandu, and treat connectivity as a bonus.'
}];
export function PlanningEssentials() {
  return <section id="planning" className="w-full bg-[#172a27] py-20 text-[#f4f0e7] sm:py-28" aria-labelledby="planning-title" data-id="element-274" data-mp="3prwk1wbwb5pr">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-275" data-mp="hbbi2zholcw5">
        <header className="grid gap-6 border-b border-white/20 pb-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end" data-id="element-276" data-mp="m4mo4yeo5pn0">
          <div data-id="element-277" data-mp="vz23k0uhlwz1">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D9CAA0]" data-id="element-278" data-mp="vxqw9r1u2736">
              Before you go
            </p>
            <h2 id="planning-title" className="mt-4 font-display text-4xl leading-tight sm:text-5xl" data-id="element-279" data-mp="mynf4sm881rb">
              The details that make the journey easier.
            </h2>
          </div>
          <p className="max-w-xl text-base leading-8 text-stone-300" data-id="element-280" data-mp="d1r34cx4cxi0">
            A little practical preparation creates more space for the trail,
            village welcomes, and the changing light around Manaslu.
          </p>
        </header>

        <div className="grid divide-y divide-white/15 md:grid-cols-2 md:divide-x md:divide-y-0" data-id="element-281" data-mp="3veyqbznknje6">
          {essentials.map(({
          title,
          detail,
          icon: Icon,
          text
        }, index) => <article key={title} className={`py-10 md:px-10 md:py-12 ${index % 2 === 0 ? 'md:pl-0' : 'md:pr-0'} ${index > 1 ? 'md:border-t md:border-white/15' : ''}`} data-id="element-282" data-mp="3qf4263v6l7wt" data-mpi={index}>
              <Icon className="h-5 w-5 text-[#D9CAA0]" aria-hidden="true" data-id="element-283" data-mp="2114d7q72p4qd" />
              <p className="mt-6 text-xs font-bold uppercase tracking-[0.18em] text-[#D9CAA0]" data-id="element-284" data-mp="25w9xkkktubcc">
                {detail}
              </p>
              <h3 className="mt-3 font-display text-3xl" data-id="element-285" data-mp="2eyj46zcz5kkg">{title}</h3>
              <p className="mt-4 max-w-xl text-sm leading-7 text-stone-300" data-id="element-286" data-mp="2exq6sozwo7ez">
                {text}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}